import * as ng from 'angular';
import * as _ from 'underscore';
import * as moment from 'moment';

import {ApiHelperService} from '../../shared';

export class ActivityLogService {
   static $inject = ['apiHelper'];

   constructor(private apiHelper:ApiHelperService) { }

   list(params) {
      return this.apiHelper.get('activitylogs', params).then(response => {
         return {
            total: response.total,
            list: _.map(response.list, decorate)
         }
      });

      function decorate(log) {
         log.created = moment(log.created).format('MMMM Do YYYY, h:mm:ssa');
         let context = ng.fromJson(log.context);

         if (context) {
            log.message = interpolate(log.message, context);
         }

         return log;
      }

      function interpolate(str:string, obj) {
         for (var key in obj) {
            str = str.replace('{' + key + '}', obj[key]);
         }
         return str;
      }
   }
}

ng.module('e360')
   .service('ActivityLogService', ActivityLogService);
